module.exports = __webpack_public_path__ + "img/layout-sidebar.60d350e7.svg";